import React from "react";
import AirlineName from "../../AirlineName/AirlineName";

const AirlineNames = ({ code }) => {
  const flightName = AirlineName;
  let airname;
  {
    flightName?.map((item) => {
      if (item?.code === code?.replace(/ /g, "")) {
        airname = item?.name;
      }
    });
  }
  return airname;
};

export default AirlineNames;
